import React from 'react';
import Flex from 'mrf/layout/Flex';
import T from 'mrf/utils/T';
import Text from 'mrf/layout/Text';

export default function SectionTitle({ children }) {
    return (
        <Flex justify='center'>
            <Text variant='h4' className='text-center font-semibold mt-3 mb-3'>
                <T>{children}</T>
            </Text>
        </Flex>
    );
}
